import { paFieldCategories, assistFieldCategories } from '../constants';

const getAllFields = (categories: { fields: string[] }[]) => categories.flatMap((c) => c.fields);

export const DEFAULT_EXCEPTION_CONFIG = {
  Invoice: {
    fields: [
      'bc.billing_client_name',
      'bc.billing_client_number',
      'cl.fill_date',
      'cl.financial_cutoff_date',
      'cl.claim_number',
      'cl.member_id',
      'cl.medical_group_number',
      'cmg.medical_group_name',
      'cl.ndc',
      'cl.drug_name',
      'cl.quantity',
      'cl.days_supply',
      'cl.claim_cost',
      'cl.patient_liability',
      'cl.plan_paid',
    ],
  },

  PA: {
    fields: getAllFields(paFieldCategories),
  },

  Assist: {
    fields: getAllFields(assistFieldCategories),
  },
};
